import { render, staticRenderFns } from "./ButtonBackPage.vue?vue&type=template&id=ada2bca0&scoped=true&lang=pug&"
import script from "./ButtonBackPage.vue?vue&type=script&lang=js&"
export * from "./ButtonBackPage.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBackPage.vue?vue&type=style&index=0&id=ada2bca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada2bca0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
